import { clearStaleBrowserCaches } from "./chunkLoadRecovery";
import { getAppAssetUrl } from "./appBasePath";

const BUILD_ID_STORAGE_KEY = "extremeb2b:build-id";
const DEPLOYMENT_RELOAD_KEY = "extremeb2b:deployment-reload-attempted-at";
const RELOAD_THROTTLE_MS = 60 * 1000;

const getEmbeddedBuildId = () =>
  process.env.REACT_APP_BUILD_ID ||
  (typeof window !== "undefined" && window.__EXTREMEB2B_BUILD_ID__) ||
  "";

const getMetaUrl = () => {
  const path = getAppAssetUrl("/meta.json");
  return `${window.location.origin}${path}`;
};

const hasRecentDeploymentReload = () => {
  const attemptedAt = Number(sessionStorage.getItem(DEPLOYMENT_RELOAD_KEY));
  return (
    Number.isFinite(attemptedAt) &&
    Date.now() - attemptedAt < RELOAD_THROTTLE_MS
  );
};

const markDeploymentReloadAttempt = () => {
  sessionStorage.setItem(DEPLOYMENT_RELOAD_KEY, String(Date.now()));
};

export const fetchDeploymentMeta = async () => {
  const response = await fetch(`${getMetaUrl()}?t=${Date.now()}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  if (!response.ok) {
    return null;
  }

  return response.json();
};

const reloadWithFreshAssets = async () => {
  if (hasRecentDeploymentReload()) {
    return false;
  }

  markDeploymentReloadAttempt();
  await clearStaleBrowserCaches();
  window.location.reload();
  return true;
};

export const ensureLatestDeployment = async () => {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  let remoteMeta = null;

  try {
    remoteMeta = await fetchDeploymentMeta();
  } catch {
    return;
  }

  if (!remoteMeta?.buildId) {
    return;
  }

  const embeddedBuildId = getEmbeddedBuildId();
  const storedBuildId = localStorage.getItem(BUILD_ID_STORAGE_KEY);
  const remoteBuildId = remoteMeta.buildId;

  const bundleIsStale =
    embeddedBuildId && embeddedBuildId !== remoteBuildId;
  const clientIsStale =
    storedBuildId && storedBuildId !== remoteBuildId;

  if (bundleIsStale || clientIsStale) {
    localStorage.setItem(BUILD_ID_STORAGE_KEY, remoteBuildId);
    await reloadWithFreshAssets();
    return;
  }

  if (!storedBuildId) {
    localStorage.setItem(BUILD_ID_STORAGE_KEY, remoteBuildId);
  }
};
